import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import { ISessionFormat } from 'constants/courses';

import { EditCard, LabelInput, LabelCheckbox } from 'components/Common';

import { FurtherDetailsSessionFormData } from 'types/cms';

interface FurtherDetailsProps extends FurtherDetailsSessionFormData {
  moduleFormatOptions: { [key in ISessionFormat]: string };
  setModuleFormat: React.Dispatch<React.SetStateAction<ISessionFormat>>;
  onSave: (formData: FurtherDetailsSessionFormData) => void;
  onCancel?: () => void;
  isDisabled?: boolean;
  isUpdating?: boolean;
  isLoading?: boolean;
  error?: boolean;
}

const noop = () => null;
const FurtherDetailsCard = ({
  moduleFormatOptions,
  moduleFormat,
  onSave,
  setModuleFormat,
  onCancel = noop,
  sessionDuration,
  requiresUpload,
  isDisabled = false,
  isUpdating = false,
  isLoading = false,
}: FurtherDetailsProps) => {
  const {
    register,
    handleSubmit,
    errors,
    clearError,
    formState,
    reset,
    watch,
  } = useForm<FurtherDetailsSessionFormData>();

  const onSubmit = handleSubmit((formData) => {
    onSave(formData);
  });

  const watchModuleFormat = watch('moduleFormat');

  useEffect(() => {
    setModuleFormat(watchModuleFormat);
  }, [watchModuleFormat, setModuleFormat]);

  useEffect(() => {
    // Reset the state as default after state change (successful update)
    reset({ moduleFormat, sessionDuration, requiresUpload });
  }, [reset, moduleFormat, sessionDuration, requiresUpload]);

  return (
    <EditCard
      onSave={onSubmit}
      onCancel={() => {
        onCancel();
        clearError();
        // TODO: Reset Select
        reset({ moduleFormat, sessionDuration, requiresUpload });
      }}
      saveDisabled={Boolean(!formState.dirty || errors.sessionDuration)}
      isDisabled={isDisabled}
      isUpdating={isUpdating}
    >
      {/* <LabelSelect
        id="moduleFormat"
        name="moduleFormat"
        label="Format"
        error={!!errors.moduleFormat}
        registerInputRef={register({
          required: true,
        })}
        defaultValue={moduleFormat}
        options={moduleFormatOptions}
        isDisabled={isDisabled}
        isLoading={isLoading}
        tooltip="session_format"
      /> */}
      <LabelInput
        id="sessionDuration"
        name="sessionDuration"
        label="Duration"
        error={!!errors.sessionDuration}
        registerInputRef={register({
          required: true,
        })}
        defaultValue={sessionDuration}
        unit="minutes"
        isDisabled={isDisabled}
        isLoading={isLoading}
        tooltip="session_duration"
        helpText="The length of time you estimate it will take a learner to complete this session."
      />
      <LabelCheckbox
        isDisabled={false}
        id="requiresUpload"
        name="requiresUpload"
        label="Post Required"
        registerInputRef={register()}
        defaultValue={sessionDuration}
        helpText="Tick this box if this session requires learners to submit a post to earn their end-of-course certificate."
      />
    </EditCard>
  );
};

export default FurtherDetailsCard;
